<ng-container *ngIf="!hideAll">
  <db-loading-circular-spinner [dsTooltip]="hideTooltip?null:'Section generation is currently underway.'"
                               hostClass="default"
                               [dsTooltipColor]="'black'"
                               dsTooltipPosition="top"
                               dsTooltipMode="hover"
                               [dsTooltipTopPxs]="11"
                               dsTooltipSize="m"
                               [newMode]="true"
                               *ngIf="loading"
                               color="new-dark"
                               size="xxs">
  </db-loading-circular-spinner>
  <i class="db-icon db-icon-ds-checkmark"
     @fadeOut
     *ngIf="!loading"
  ></i>
</ng-container>

